import React, { useEffect, useState } from 'react';
import { useTrainingJobs } from 'src/hooks/useTrainingJobs';
import { ContentLayout } from 'src/components/ContentLayout';
import { TrainingJobTable } from 'src/components/TrainingJobTable';
import { TrainingJob } from 'src/context/apiState';

import { MonitoringScheduleTable } from 'src/components/MonitoringScheduleTable';
import { useMonitoringSchedules } from 'src/hooks/useMonitoringSchedules';
import { MetricsChart } from 'src/components/MetricsChart';
import { useParams } from 'react-router-dom';

export const ModelMetricsPage = () => {
  const { modelArtifactId } = useParams();

  const [metricsLoading, metricsError, metricsData] = useTrainingJobs(
    modelArtifactId || '',
  );

  const [
    monitoringSchedulesLoading,
    monitoringSchedulesError,
    monitoringSchedulesData,
  ] = useMonitoringSchedules(modelArtifactId || '');

  const [metricNames, setMetricNames] = useState<Set<string> | null>(null);

  // loop through all the jobs and their metrics, build a list of metric names
  useEffect(() => {
    if (!metricsData) return;

    const names = metricsData.reduce(
      (namesSet: Set<string>, job: TrainingJob) => {
        job.metrics?.forEach((metric) => namesSet.add(metric.MetricName));
        return namesSet;
      },
      new Set<string>(),
    );

    setMetricNames(names.size > 0 ? names : null);
  }, [metricsData]);

  return (
    <ContentLayout
      heading={
        <>
          <h1>Model Metrics</h1>
        </>
      }
    >
      <>
        <MetricsChart
          heading={<h2>Training Metrics</h2>}
          loading={metricsLoading}
          error={metricsError}
          data={metricsData}
          metricNames={metricNames}
        />
        <section className="training-jobs">
          <TrainingJobTable
            loading={metricsLoading}
            data={metricsData}
            error={metricsError}
            metricNames={metricNames}
          />
        </section>
        <section className="training-jobs">
          <MonitoringScheduleTable
            loading={monitoringSchedulesLoading}
            data={monitoringSchedulesData}
            error={monitoringSchedulesError}
          />
        </section>
      </>
    </ContentLayout>
  );
};
